<div class="error-popup">
  <button mat-mini-fab class="close-dialog-btn" (click)="onNoClick()"><i class="material-icons">close</i></button>
  <div mat-dialog-content>
    <div>
      <div class="error-popup-title">Error!</div>
      <div>
        {{genericErrorMsg}}
      </div>
      <div *ngIf="apiErrorMsg">
        <div>
          <button class="show-details-button" (click)="showErrorDetail = !showErrorDetail">Show Details</button>
        </div>
        <div class="detail-error-content" *ngIf="showErrorDetail">
          {{apiErrorMsg}}
        </div>
      </div>
    </div>
  </div>
</div>